export default __webpack_public_path__ + "static/media/duaLipa.32150067.jpg";